export default "__VITE_ASSET__fc632d11__"